// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"371":"75f53620","375":"82d6aa02","453":"82d6aa02","463":"82d6aa02","877":"82d6aa02"}[chunkId] + ".chunk.css";
};